import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Stack } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import BottomButtonsforWorkOrder from "./BottomButtonsforWorkOrder";
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { getModifiedBy } from "../../utility/tokenUtility";
import { useLocation } from "react-router-dom";
import { mandatoryFields } from "../../redux/actions/assetActions";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { processingPercentageValue, statusList } from "../../utility/message";
import { formatDate } from "date-fns";


const CostInfo = ({ setPage, page, buttonAttributes }) => {

    //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );

    const dispatch = useDispatch();
    const location = useLocation();
    const basicDetails = useSelector((state) => state.workOrderBasicDetails);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const viewmode = location.state?.viewmode;
    const completionInfoData = basicDetails?.completionInfo || {};
    const costInfo = basicDetails?.completionInfo?.costInfo || {};
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const categoryType = assetCategoryType?.category;
    const categoryFieldName = assetCategoryType?.category === "Scheduled" ? "scheduled" : "unscheduled";
    const disableFields = categoryType === "Scheduled" ? true : false;
    const setOutsourceDetails = basicDetails?.vendorField === false ? false : true;
    const partReplacementRows = basicDetails?.partReplacementRows || [];
    const totalSparePartCost = partReplacementRows?.reduce((acc, part) => acc + parseFloat(part?.partCost || 0), 0) || 0;

    const [costInfoData, setCostInfoData] = useState(costInfo || {});
    const [errorDialog,setErrorDialog] = useState(false);
    const [errorDialogMssg,setErrorDialogMssg] = useState("");
    
    const statusMapping = {
        "Open": 1,
        "In Progress": 3,
        "Completed": 4,
        "Closed": 5,
        "Cancelled": 6,
        "Verified": 8,
        "Not Done and Closed":7,
        "Completed-Outsource":9,
    };

    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value

    const handleOnchange = (value, name) => {

        const formatNumericValue = (value, previousValue) => {
            if (value === "") return ""; // Allow empty input
          
            // Check if the value is a valid numeric input (includes decimal point)
            if (/^\d*\.?\d*$/.test(value)) {
              if (previousValue === "0.00") return value; // Replace `0.00` entirely with the user's input
          
              // If the input is purely zeros or starts with zeros and a decimal
              if (/^0+(\.0*)?$/.test(value)) {
                return "0"; // Keep it as "0" for clarity
              }
          
              // Remove leading zeros for integers
              if (!value.includes(".")) {
                return value.replace(/^0+/, "") || "0"; // Keep "0" if the result becomes empty
              }
          
              // Split the value into integer and decimal parts
              const [integerPart, decimalPart] = value.split(".");
              if (Number(integerPart) === 0) {
                return decimalPart ? `0.${decimalPart.replace(/^0+/, "").slice(0, 2)}` : "0."; // Retain "0." for clarity and limit to 2 decimal places
              }
          
              // Default valid case
              return `${integerPart.replace(/^0+/, "") || "0"}.${decimalPart.slice(0, 2)}`; // Remove leading zeros and limit to 2 decimal places
            }
          
            return previousValue; // Retain the previous valid value if input is invalid
          };

        setCostInfoData((previous) => {
          let updatedValue = value;
      
          // Apply formatting for specific fields
          if (["breakDownCost", "ppmCostByPurchaseOrder", "ppmCostByContract","totalSparePartCost","totalWorkorderCost"].includes(name)) {
            updatedValue = formatNumericValue(value, previous[name]);
          }
      
          const updatedData = {
            ...previous,
            [name]: updatedValue,
          };
      
          // Calculate totalWorkorderCost for specific fields
          const parsedValue = parseFloat(updatedData[name]) || 0;
          const parsedTotalSparePartCost = parseFloat(totalSparePartCost) || 0;
      
          if (name === "breakDownCost") {
            updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
          } else if (name === "ppmCostByPurchaseOrder") {
            updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
          } else if (name === "ppmCostByContract") {
            updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
          }
      
          return updatedData;
        });
      };

      
    const handleSubmit = async (event) => {
        event.preventDefault();
        const acceptedById = basicDetails?.assessments?.respondedBy?.id || ""
        const APIPayload = {
            rootcause: completionInfoData?.rootCause || "",
            completedbyempid: completionInfoData?.completionBy?.id || "",
            startdate: completionInfoData?.startDateandTime || "",
            enddate: completionInfoData?.endDateandTime || "",
            acceptedbyid: completionInfoData?.respondedBy?.id || acceptedById || "",
            isassetreqnotavail: completionInfoData?.isassetreqnotavail || false,
            actiontaken: completionInfoData?.actionTaken || "",
			downtimehours: completionInfoData?.downTimeHours || "",
            sparepartscost: totalSparePartCost || "",
            ppmcost: costInfoData?.ppmCostByPurchaseOrder || "",
            ppmcostpurorderno: costInfoData?.poNumberByPurchaseOrder || "",
            contractppmcost: costInfoData?.ppmCostByContract || "",
            contractrefno: costInfoData?.contractReferenceNumber || "",
            breakdowncost: costInfoData?.breakDownCost || "",
            breakdowncostpurorderno: costInfoData?.poNumber || "",
            totalwocost: costInfoData?.totalWorkorderCost || "",
            id: completionInfoData?.id || "",
            [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
            acceptedbyid: completionInfoData?.respondedBy?.id || "",
            timestamp: completionInfoData?.timeStamp || "",
            authorizedbyid:basicDetails?.completionInfo?.costInfo?.Authorizedbyid || basicDetails?.Closedid || "" ,
            authorizeddate:basicDetails?.completionInfo?.costInfo?.Authorizeddate || basicDetails?.Closeddate || "" 
        };
        if (processingPercentage > 90 && !viewmode && mappedStatus !==6 && mappedStatus !==7) {
            const updateCompletionInfo = await workOrderSummaryRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload, categoryType);
            
            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id, timeStamp: updateCompletionInfo?.timestamp || "" } });
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                setPage("Authorization & Summary");
                // setPage("Attachments");
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
              }

        } else if ((mappedStatus === 4 && processingPercentage > 90) || mappedStatus === 5) {
            const updateCompletionInfo = await workOrderSummaryRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload, categoryType);
            
            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id, timeStamp: updateCompletionInfo?.timestamp || "" } });
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                setPage("Authorization & Summary");
                // setPage("Attachments");
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
              }

        } else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7 ){
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            setPage("Authorization & Summary");
            // setPage("Attachments");
        } else {
            const updateCompletionInfo = await workOrderSummaryRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload, categoryType);

            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id, timeStamp: updateCompletionInfo?.timestamp || "" } });
                await workOrderSummaryRepositry.workorderStatusValue(serviceType, basicDetails?.id,status === "Verified" ? statusList?.verified?.id : mappedStatus, processingPercentageValue?.costInfo, basicDetails?.category?.id);
                dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: processingPercentageValue?.costInfo }));
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
                setPage("Authorization & Summary");
                // setPage("Attachments");
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
              }
        };
    };
    
    useEffect(() => {
        // Initial calculation when the component mounts or values change
        const breakDownCost = parseFloat(costInfoData.breakDownCost) || 0;
        const ppmCostByPurchaseOrder = parseFloat(costInfoData.ppmCostByPurchaseOrder) || 0;
        const ppmCostByContract = parseFloat(costInfoData.ppmCostByContract) || 0;
        const totalSparePartCosts = parseFloat(totalSparePartCost) || 0;

        // Update total cost with initial or current values
        const totalCost = categoryType ==="Scheduled" ?  ppmCostByPurchaseOrder + ppmCostByContract + totalSparePartCosts :
            breakDownCost  + totalSparePartCosts;

        setCostInfoData((prevData) => ({
            ...prevData,
            totalWorkorderCost: totalCost,
            totalSparePartCost:totalSparePartCosts

        }));
        
    }, [costInfoData.breakDownCost, costInfoData.ppmCostByPurchaseOrder, costInfoData.ppmCostByContract, totalSparePartCost]);

    const handleCloseErrRequestDialog = () => {
		setErrorDialog(false);
		setErrorDialogMssg("");
	};
	
	const handleConfirmErrRequestDialog = (e) => {
		e.preventDefault();
		setErrorDialog(false);
		setErrorDialogMssg("")
	};

    return (
        <>
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
            />
            <Box >
                <form style={{ position: "relative" }} onSubmit={handleSubmit} noValidate>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.workOrderNo || ""}</Typography>
                    </Stack>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>

                        {!disableFields && (
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={4.5} sm={6}>
                                    <CustomTextField
                                        label="Breakdown Cost in RM (by purchase order)"
                                        id="breakDownCost"
                                        name="breakDownCost"
                                        value={costInfoData?.breakDownCost || 0}
                                        onChange={handleOnchange}
                                        placeholder={"0.00"}
                                        disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                        textAlign="right"
                                        autoFocus
                                        onlyNumbers={true}
                                        numbersLength={13}
                                        allowDecimal={true}

                                    />
                                </Grid>
                                <Grid item xs={6} md={4.5} sm={6}>
                                    <CustomTextField
                                        label="PO Number"
                                        id="poNumber"
                                        name="poNumber"
                                        onChange={handleOnchange}
                                        value={costInfoData?.poNumber}
                                        placeholder={"Enter PO Number"}
                                        disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </Box>
                    <Box mb={2}>
                        {disableFields && setOutsourceDetails === false && (<Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PPM Cost in RM (by purchase order)"
                                    id="ppmCostByPurchaseOrder"
                                    name="ppmCostByPurchaseOrder"
                                    onChange={handleOnchange}
                                    value={costInfoData?.ppmCostByPurchaseOrder || 0}
                                    placeholder={"0.00"}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    textAlign="right"
                                    autoFocus
                                    onlyNumbers={true}
                                    numbersLength={13}
                                    allowDecimal={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PO Number"
                                    id="poNumberByPurchaseOrder"
                                    name="poNumberByPurchaseOrder"
                                    onChange={handleOnchange}
                                    placeholder={"Enter PO Number"}
                                    value={costInfoData?.poNumberByPurchaseOrder}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    
                                />
                            </Grid>
                        </Grid>
                        )}
                    </Box>
                    <Box mb={2}>
                        {disableFields && setOutsourceDetails === true && (<Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PPM Cost in RM (by Contract)"
                                    id="ppmCostByContract"
                                    name="ppmCostByContract"
                                    onChange={handleOnchange}
                                    placeholder={"0.00"}
                                    value={costInfoData?.ppmCostByContract || 0}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    textAlign="right"
                                    autoFocus
                                    onlyNumbers={true}
                                    numbersLength={13}
                                    allowDecimal={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Contract Reference Number"
                                    id="contractReferenceNumber"
                                    name="contractReferenceNumber"
                                    onChange={handleOnchange}
                                    placeholder={"Enter CR Number"}
                                    value={costInfoData?.contractReferenceNumber}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                />
                            </Grid>
                        </Grid>)}
                    </Box>
                    <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Spare Part Cost in RM (Link with inventory Submodule)"
                                    id="totalSparePartCost"
                                    name="totalSparePartCost"
                                    value={costInfoData?.totalSparePartCost || 0}
                                    allowDecimal={true}
                                    // value={totalSparePartCost ? parseFloat(totalSparePartCost || 0)?.toFixed(2) : 0}
                                    textAlign="right"
                                    onChange={handleOnchange}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    // disabled
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' > Total Work Order Cost</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Total WO Cost in RM"
                                    id="totalWorkorderCost"
                                    name="totalWorkorderCost"
                                    value={costInfoData?.totalWorkorderCost || 0}
                                    allowDecimal = {true}
                                    // value={costInfoData?.totalWorkorderCost ? parseFloat(costInfoData?.totalWorkorderCost || 0)?.toFixed(2) : 0}
                                    textAlign="right"
                                    onChange={handleOnchange}
                                    disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                                    // disabled
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <BottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} />
                    </Box>
                </form>
            </Box>
            <CustomAlert
				open={errorDialog}
				onClose={handleCloseErrRequestDialog}
				onConfirm={handleConfirmErrRequestDialog}
				content={errorDialogMssg}
				confirmBtn='OK'
			/>
        </>
    );
};

export default CostInfo;
